import {create} from 'zustand/react'

// Тип состояния хранилища.
export interface ModalsStoreType {
    // Данные.
    loginModalVisible: boolean | null

    // Модальное окно фильтрации по локации.
    locationFilterModalVisible: boolean | null

    // Модальное окно выбора локации пользователя.
    userLocationModalVisible: boolean | null

    // API:

    // Закрыть все окна, размещенные вне содержимого страницы (глобальные).
    // Окна, размещенные внутри страниц, закроются при unmount компонента страницы.
    hideModals: () => void

    /**
     * Показать модальное окно авторизации пользователя.
     * Не использовать напрямую!
     * @see AuthStoreType.initUserAuth
     */
    showLoginModal: () => void

    /**
     * Скрыть модальное окно авторизации пользователя.
     * Не использовать напрямую!
     * @see AuthStoreType.cancelUserAuth
     * @see AuthStoreType.finishUserLogin
     */
    hideLoginModal: (unmount?: boolean) => void

    // Показать модальное окно фильтрации по локации.
    showLocationFilterModal: () => void

    // Скрыть модальное окно фильтрации по локации.
    hideLocationFilterModal: (unmount?: boolean) => void

    // Показать модальное окно выбора локации пользователя.
    showUserLocationModal: () => void

    // Скрыть модальное окно выбора локации пользователя.
    hideUserLocationModal: (unmount?: boolean) => void
}

/**
 * Хранилище состояния открытости глобальных модальных окон.
 */
export const useModalsStore = create<ModalsStoreType>(
    (set, get) => ({
        loginModalVisible: false,
        locationFilterModalVisible: false,
        userLocationModalVisible: false,

        // API:

        hideModals(): void {
            get().hideLoginModal(true)
            get().hideLocationFilterModal(true)
            get().hideUserLocationModal(true)
        },

        showLoginModal(): void {
            set({
                loginModalVisible: true,
            })
        },

        hideLoginModal(unmount: boolean = false): void {
            set({
                loginModalVisible: unmount ? null : false,
            })
        },

        // Показать модальное окно фильтрации по локации.
        showLocationFilterModal(): void {
            set({
                locationFilterModalVisible: true,
            })
        },

        // Скрыть модальное окно фильтрации по локации.
        hideLocationFilterModal(unmount: boolean = false): void {
            set({
                locationFilterModalVisible: unmount ? null : false,
            })
        },

        // Показать модальное окно выбора локации пользователя.
        showUserLocationModal(): void {
            set({
                userLocationModalVisible: true,
            })
        },

        // Скрыть модальное окно выбора локации пользователя.
        hideUserLocationModal(unmount: boolean = false): void {
            set({
                userLocationModalVisible: unmount ? null : false,
            })
        },
    })
)
